export interface AuthenticationState {
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  refresh_token: string;
  token_type: string;
  not_before_policy: number;
  session_state: string;
  scope: string;
  firstName: string;
  lastName: string;
  vuaId: string;
}

const initialState: AuthenticationState = {
  access_token: "",
  expires_in: 0,
  refresh_expires_in: 0,
  refresh_token: "",
  token_type: "",
  not_before_policy: 0,
  session_state: "",
  scope: "",
  firstName: "",
  lastName: "",
  vuaId: "",
};

export default function authenticationReducer(
  state: AuthenticationState = initialState,
  action: any
) {
  switch (action.type) {
    case "SAVE_TOKEN":
      return {
        ...state,
        access_token: action.payload.access_token,
        expires_in: action.payload.expires_in,
        refresh_expires_in: action.payload.refersh_expires_in,
        refresh_token: action.payload.refresh_token,
        token_type: action.payload.token_type,
        not_before_policy: action.payload.not_before_policy,
        session_state: action.payload.session_state,
        scope: action.payload.scope,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        vuaId: action.payload.vuaId,
      };
    default:
      return state;
  }
}
